var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    transform: "matrix(-4.37114e-08 1 -1 -1.05524e-06 100 0.279053)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.2791,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#E5F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 50.4158C72.5 37.9108 62.4294 27.7791 50 27.7791C37.5706 27.7791 27.5 37.9108 27.5 50.4158C27.5 61.7341 35.6653 71.1357 46.4617 72.7786L46.4617 56.9877L40.746 56.9877L40.746 50.4158L46.4617 50.4158L46.4617 45.4868C46.4617 39.8276 49.8185 36.6329 54.8992 36.6329C57.4395 36.6329 59.9798 37.0893 59.9798 37.0893L59.9798 42.6572L57.1673 42.6572C54.3548 42.6572 53.4476 44.3915 53.4476 46.217L53.4476 50.4158L59.7077 50.4158L58.7097 56.9877L53.4476 56.9877L53.4476 72.7786C64.2439 71.1357 72.5 61.7341 72.5 50.4158Z",
    fill: "#0094FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventFacebook);
export default __webpack_public_path__ + "static/media/canvas_event_facebook.1b7a89e89d141bef2d57e665395153b9.svg";
export { ForwardRef as ReactComponent };